import {
  ViewEncapsulation, Injectable, Component,
  OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter, OnDestroy
} from "@angular/core";

@Component({
  selector: "app-phasor-chart",
  templateUrl: "./phasor-chart.component.html",
  styleUrls: ["./phasor-chart.component.css"]
})
export class PhasorChartComponent implements OnInit, OnChanges, OnDestroy {

  constructor() { }
  @Input() VA = 0;
  @Input() VB = 0;
  @Input() VC = 0;
  @Input() IA = 0;
  @Input() IB = 0;
  @Input() IC = 0;
  totalWidth = 360;
  totalHeight = 360;
  circleR = 150;
  ngOnInit() { return; }
  ngOnDestroy() { return; }
  async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    return;
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/phasor-chart/phasor-chart.component.ts